import { EformApiClient } from '@qcm/eforms-client'
import { SERVER_URL } from './settings'

EformApiClient.initApi(SERVER_URL!)

export default EformApiClient
